import React, { FunctionComponent } from "react";
import { GridRow, GridCell, Typography } from "@episerver/ui-framework";
import variables from "@episerver/design-tokens/dist/json/variables";
import { DesignTokenColor } from "./design-token-color";

import "./typography-variables.scss";

interface DesignToken {
    name: string;
}

interface Color extends DesignToken {
    hex: string;
    alpha: number;
}

interface Typography extends DesignToken {
    letterSpacing: number;
    lineHeight: number;
    font: {
        postscriptName: string;
        family: string;
        size: number;
        weight: string;
        stretch: string;
    };
    color: Color;
}

const typography: Typography[] = variables
    .filter((v: Typography) => v.name?.startsWith("typography"));

export const TypographyVariables: FunctionComponent = () => (
    <>
        {typography.map(t => (
            <GridRow key={t.name} className="epi-ds-site-typography-variables--row">
                <GridCell span={6}>
                    <span style={{
                        letterSpacing: t.letterSpacing,
                        lineHeight: `${t.lineHeight}px`,
                        fontFamily: t.font.family,
                        fontSize: t.font.size,
                        fontWeight: t.font.weight,
                        fontStretch: t.font.stretch,
                        color: `#${t.color.hex}`,
                        opacity: t.color.alpha
                    }}>
                        {t.name}
                    </span>
                </GridCell>
                <GridCell span={6}>
                    <Typography use="subtitle1" tag="p">
                        {t.font.family}, {t.font.weight}, {t.font.size}
                        <DesignTokenColor color={`#${t.color.hex}`} alpha={t.color.alpha} name={`${t.color.hex}, ${t.color.alpha} opacity`} />
                    </Typography>
                    <Typography use="subtitle2" tag="p">Line height: {t.lineHeight}px, Letter spacing: {t.letterSpacing}px</Typography>
                </GridCell>
            </GridRow>
        ))}
    </>
);
